import React from 'react';
import { Box, HintPlacement, Inscription, SimpleHint } from '@common-fe/common-fe';

export const INACTIVE_ORGANIZATION_HINT_TEXT =
  'Child organizations cannot be created because your organization is inactive.';

interface Props {
  isInactive: boolean;
  children: React.ReactNode;
  testId?: string;
}

const InactiveOrganizationHint: React.FC<Props> = ({
  isInactive,
  children,
  testId = 'inactive-organization-hint',
}) => {
  if (!isInactive) {
    return <>{children}</>;
  }

  return (
    <SimpleHint
      preferAlign={HintPlacement.LEFT}
      isFixed
      usePortal
      width="220px"
      round="container1Round"
      testId={testId}
      content={
        <Box data-testid={`${testId}_text`}>
          <Inscription size="small" weight={500} color="textOnColor" textAlign="center" lineHeight="18px">
            {INACTIVE_ORGANIZATION_HINT_TEXT}
          </Inscription>
        </Box>
      }
    >
      {children}
    </SimpleHint>
  );
};

export default InactiveOrganizationHint;
